<template>
  <BaseSection :step="step">

    <template #title>Update Add Ons</template>

    <template #content>


      <template v-for="(addon,index) in getAddons">
        <AddonsDisplay :addon="addon" :key="index" />
      </template>

      <v-row>
        <v-col>
          <v-btn color="primary" outlined class="my-0 mr-2" @click="submitBack">Back</v-btn>
          <v-btn color="primary" class="my-0" @click="submitContinue" :disabled="disableContinue" :loading="getAddonsLoading">Continue</v-btn>
        </v-col>
      </v-row>

    </template>

  </BaseSection>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/BaseSection';
  import AddonsDisplay from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/all/AddonsDisplay';
  
  export default {
    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: { BaseSection,AddonsDisplay },

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection','getAddons','getTariffs','getAddonsLoading']),
      ...mapGetters('products',['getCurrentProduct']),

      disableContinue(){
        return this.getAddonsLoading || this.getAddons.filter(e=>e.selectError).length!==0;
      },
    },

    watch: {
      getCurrentStep(val) {
        if(val===this.step){
          if(this.getAddons.length===0){
            this.fetchAddons(this.getCurrentProduct);
          }

        }
        if(this.step!==3){
          if(this.getTariffs.length===0){
            this.fetchTariffs(this.getCurrentProduct);
          }else{
            this.set_previous_tariffs(this.getCurrentProduct);
          }
        }
      }
    },

    methods: {
      ...mapActions('changeTariff',['fetchAddons','fetchTariffs']),
      ...mapMutations('changeTariff',['set_section','set_stepNext','set_stepPrev','set_previous_tariffs']),

      submitContinue(){
        this.set_stepNext();
      },

      submitBack(){
        this.set_stepPrev();
      },
    },
  }
</script>

<style lang="scss" scoped></style>
